<template>
  <modal v-if="show"
         :hide-buttons="true"
         :close-on-click-outside="false"
         title="AI Text Generator"
         @mounted="init()"
         @destroy="show = false">
    <template>
      <hm-card-inner>
        <spinner-overlay v-if="generating" />
        <hm-select v-model="aiRequest.targetLanguage"
                   :options="getI18nLanguages($shortLocale)"
                   label="Zielsprache / Target Language"
                   name="targetLanguage" />
        <hm-textarea v-model="aiRequest.keywords"
                     :lazy="true"
                     label="Zusatzinformationen / Additional Information"
                     name="aiKeywords"
                     cols="12">
          <hm-select v-model="aiRequest.keywordLanguage"
                     :options="getI18nLanguages($shortLocale)"
                     label="Sprache der Zusatzinformationen / Additional Information Language"
                     name="keywordLanguage" />
        </hm-textarea>

        <hm-button cols="12"
                   class="btn--orange"
                   icon-left="magic-wand"
                   @click="doMagic">Text erstellen / Generate text</hm-button>
        <hm-textarea v-model="result"
                     :lazy="true"
                     :disabled="true"
                     :input-rows="10"
                     label="AI Text"
                     name="aiDescription"
                     cols="12" />

        <hm-button :disabled="isEmpty(result)"
                   cols="12"
                   class="btn--no-margin btn--orange"
                   icon-left="copy"
                   @click="$copy(result)">In Zwischenablage kopieren / Copy to clipboard</hm-button>
      </hm-card-inner>
    </template>
  </modal>
</template>

<script>

import HotelmeisterMixin from '../../../mixins/HotelmeisterMixin';
import Modal from './Modal';
import HmCardInner from '../layout/HmCardInner';
import HmCol from '../layout/HmCol';
import uuid from 'uuid';
import { isEmpty, isNil } from 'lodash';

export default {
  name: 'AiTextGenerator',
  components: { Modal, HmCardInner, HmCol },

  mixins: [HotelmeisterMixin],

  data() {
    return {
      show: false,
      url: null,
      aiRequest: {
        keywords: null,
        keywordLanguage: null,
        targetLanguage: null,
      },
      result: null,
      generating: false,
    };
  },

  created: function () {
    this.$serviceBus.$on('aiTextGenerator.show', (url) => {
      this.show = true;
      this.url = url;
      this.aiRequest.keywordLanguage = this.$shortLocale || this.hotelSettings.details.primaryLanguage;
      this.aiRequest.targetLanguage = this.hotelSettings.details.primaryLanguage || this.$shortLocale;
      this.result = null;
    });
  },

  beforeDestroy: function () {
    this.$serviceBus.$off('aiTextGenerator.show');
  },

  mounted: function () {
  },

  methods: {
    init() {
    },
    doMagic() {
      if (this.generating === true) return;
      this.generating = true;
      this.axios.post(this.url, this.aiRequest)
        .then((response) => {
          this.result = response.data.data;
        })
        .catch((error) => {
          this.showMessages(error.response);
        })
        .catch((error) => {
          if (isNil(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        })
        .finally(() => {
          this.generating = false;
        });
    },
  },
};
</script>

<style lang="scss">
  @import '~styles/import';

  button.gsc-search-button {
    cursor: pointer;
    border-radius: 3px;

    &:hover {
      background-color: darken($mint, 5%);
      border-color: darken($mint, 5%);
    }
  }

  .gcsc-more-maybe-branding-root {
    * {
      pointer-events: none !important;
      cursor: default !important;
      color: white !important;
      fill: white!important;
      stroke: white!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/util/AiTextGenerator.vue